module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge borderless menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n      Selected date:\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dateMinus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow left"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.datePlus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [(_vm.loading) ? _c('i', {
    staticClass: "circle notched loading icon"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "small add-reservation item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.startCreateReservation($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Reservation")])]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "30px"
    },
    attrs: {
      "id": "segment"
    }
  }, [_c('h4', {
    staticClass: "ui red header"
  }, [_vm._v("\n      Buchungsbeginn zur vollen Stunde\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "ui definition celled bottom attached fifteen column table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "two wide"
  }), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('th', {
      staticClass: "center aligned",
      attrs: {
        "id": hour == '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)
      }
    }, [_vm._v("\n          " + _vm._s(hour) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.boatsStartFull), function(boat) {
    return _c('tr', {
      key: boat._id,
      class: {
        'thick-border': _vm.boats[_vm.boats.indexOf(boat) - 1] && boat.type !== _vm.boats[_vm.boats.indexOf(boat) - 1].type
      }
    }, [_c('td', {
      staticClass: "center aligned boat-title",
      class: {
        'out': boat.state.currentlyOut
      }
    }, [_c('span', {
      staticClass: "title",
      class: {
        'hidden': boat.hidden
      }
    }, [_vm._v("\n            " + _vm._s(boat.name) + " "), (boat.hidden) ? _c('i', {
      staticClass: "hide icon"
    }) : _vm._e()]), _vm._v(" "), (boat.state.currentlyOut) ? _c('span', {
      staticStyle: {
        "font-size": "12px",
        "color": "#c54700"
      }
    }, [_c('br'), _vm._v("IN USE "), (boat.state.currentlyOut) ? _c('i', {
      staticClass: "circle notched loading icon"
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.hours), function(hour, index) {
      return _c('booking-choice', {
        key: boat._id + '-' + hour.index,
        attrs: {
          "hour": hour,
          "hourIndex": index,
          "boat": boat,
          "hours": _vm.hours,
          "selected": _vm.selected,
          "date": _vm.date,
          "id": boat._id + '-' + index,
          "move": _vm.move,
          "create": _vm.create,
          "settings": _vm.settings,
          "updatedBooking": _vm.updatedBooking,
          "allBookings": _vm.allBookings
        },
        on: {
          "selected": _vm.selected,
          "triggerDetails": _vm.openReservationDetails,
          "moveBooking": _vm.moveBooking,
          "moveTo": _vm.moveTo,
          "selectForCreate": _vm.selectForCreate
        }
      })
    })], 2)
  }))]), _vm._v(" "), (_vm.ruler.visible) ? _c('div', {
    style: ({
      width: '2px',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'red',
      top: '0px',
      left: _vm.ruler.left
    })
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "120px"
    },
    attrs: {
      "id": "segment2"
    }
  }, [_c('h4', {
    staticClass: "ui red header"
  }, [_vm._v("\n      Buchungsbeginn zur halben Stunde\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "ui definition celled bottom attached table",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "two wide",
    staticStyle: {
      "width": "119px !important"
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('th', {
      staticClass: "center aligned",
      staticStyle: {
        "width": "86px !important"
      },
      attrs: {
        "id": hour == '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)
      }
    }, [_vm._v("\n          " + _vm._s((parseInt(hour.split(' - ')[0]) - 1) + ':30')), _c('br'), _vm._v("-"), _c('br'), _vm._v(_vm._s((parseInt(hour.split(' - ')[1]) - 1) + ':30') + "\n        ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.boatsStartHalf), function(boat) {
    return _c('tr', {
      key: boat._id,
      class: {
        'thick-border': _vm.boats[_vm.boats.indexOf(boat) - 1] && boat.type !== _vm.boats[_vm.boats.indexOf(boat) - 1].type
      }
    }, [_c('td', {
      staticClass: "center aligned boat-title",
      class: {
        'out': boat.state.currentlyOut
      }
    }, [_c('div', {
      staticClass: "title",
      class: {
        'hidden': boat.hidden
      },
      staticStyle: {
        "width": "105px"
      }
    }, [_vm._v("\n            " + _vm._s(boat.name) + " "), (boat.hidden) ? _c('i', {
      staticClass: "hide icon"
    }) : _vm._e()]), _vm._v(" "), (boat.state.currentlyOut) ? _c('div', {
      staticStyle: {
        "font-size": "12px",
        "color": "#c54700"
      }
    }, [_vm._v("IN USE "), (boat.state.currentlyOut) ? _c('i', {
      staticClass: "circle notched loading icon"
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.hours), function(hour, index) {
      return _c('booking-choice', {
        key: boat._id + '-' + hour.index,
        attrs: {
          "hour": hour,
          "hourIndex": index,
          "boat": boat,
          "hours": _vm.hours,
          "selected": _vm.selected,
          "date": _vm.date,
          "id": boat._id + '-' + index,
          "move": _vm.move,
          "create": _vm.create,
          "settings": _vm.settings,
          "updatedBooking": _vm.updatedBooking,
          "allBookings": _vm.allBookings
        },
        on: {
          "selected": _vm.selected,
          "triggerDetails": _vm.openReservationDetails,
          "moveBooking": _vm.moveBooking,
          "moveTo": _vm.moveTo,
          "selectForCreate": _vm.selectForCreate
        }
      })
    })], 2)
  }))]), _vm._v(" "), (_vm.ruler.visible) ? _c('div', {
    style: ({
      width: '2px',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'red',
      top: '0px',
      left: _vm.ruler.left
    })
  }) : _vm._e()]), _vm._v(" "), (_vm.move.status) ? _c('div', {
    staticClass: "bottom-message"
  }, [_c('div', {
    staticClass: "ui icon floating message"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Select the slot to move the reservation to\n        ")]), _vm._v(" "), _c('p', [_vm._v("You are moving the reservation "), _c('strong', [_vm._v(_vm._s(_vm.move.booking.reservation.code))]), _vm._v("\n          from "), _c('strong', [_vm._v(_vm._s(_vm.move.booking.date))]), _vm._v(", boat "), _c('strong', [_vm._v(_vm._s(_vm.move.booking.boat.name))]), _vm._v("\n          at "), _c('strong', [_vm._v(_vm._s(_vm.move.booking.hour) + "h")])]), _vm._v(" "), _c('div', {
    staticClass: "ui negative tiny button",
    on: {
      "click": function($event) {
        _vm.move.status = false
      }
    }
  }, [_vm._v("Cancel moving")])])])]) : _vm._e(), _vm._v(" "), (_vm.create.status) ? _c('div', {
    staticClass: "bottom-message"
  }, [_c('div', {
    staticClass: "ui icon floating message"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Select slots to create reservation for\n        ")]), _vm._v(" "), _c('p', [_vm._v("Please select the slots to book for the new reservation.")]), _vm._v(" "), (_vm.create.selected.length > 0) ? _c('div', {
    staticClass: "ui positive tiny button",
    on: {
      "click": _vm.showNewReservationModal
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Create Reservation")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui negative basic tiny button",
    on: {
      "click": function($event) {
        _vm.create.status = false;
        _vm.create.selected = []
      }
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('details-modal', {
    attrs: {
      "reservationProp": _vm.editReservation,
      "boats": _vm.boats
    }
  }), _vm._v(" "), _c('new-reservation-modal', {
    attrs: {
      "selected": _vm.create.selected
    },
    on: {
      "reservationCreated": function($event) {
        _vm.create.status = false;
        _vm.create.selected = []
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar item"
  }, [_c('div', {
    staticClass: "ui basic calendar"
  }, [_c('div', {
    staticClass: "ui huge icon input"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "date",
      "placeholder": "Datum"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9405639e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Booking.vue
// module id = 747
// module chunks = 1